// Module
var code = "<printerless-info></printerless-info>";
// Exports
var _module_exports =code;;
var path = '/r2/views/printerless-info.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;